import { Observable } from 'rxjs'
import interact from 'interactjs'

export class ChatComponent {
    constructor() {
        this.chat = document.querySelector('#ubots-webchat-icon')
        this.isMobile = this.checkMobileDevice()
        this.createInteract()
        this.tapInteract()
    }

    checkMobileDevice() {
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    createInteract() {
        if(this.chat && this.isMobile == true) {
            interact(this.chat)
              .draggable({
                onmove: dragMoveListener
              })

            function dragMoveListener (event) {
              var target = event.target
              // keep the dragged position in the data-x/data-y attributes
              var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
              var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

              // translate the element
              target.style.webkitTransform =
                target.style.transform =
                  'translate(' + x + 'px, ' + y + 'px)'

              // update the posiion attributes
              target.setAttribute('data-x', x)
              target.setAttribute('data-y', y)
            }
        }
    }

    tapInteract(){
      if (this.chat) {
        interact(this.chat).on('tap', function (event) {
            UbotsWC.openChat()
        })
      }
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/chat.component.js